import { getCompanyInfo } from '@/containers/CompanyInfo/_api'
import { useQuery } from '@tanstack/react-query'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'

export default function CompanyInfo() {
  const { data: companyInfo } = useQuery({
    queryKey: ['companyInfo'],
    queryFn: getCompanyInfo,
    select: data => data.data,
  })
  const { t } = useTranslation('common')

  return companyInfo ? (
    <>
      <div className="flex items-center gap-2">
        <Link
          className="font-pretendard py-2 text-xs font-medium leading-normal text-normal"
          href="/my/term-of-service"
          target="_blank"
        >
          {t('companyInfo.links.tos')}
        </Link>
        <div className="h-1 w-1 rounded-full bg-gray-800"></div>
        <Link
          className="font-pretendard py-2 text-xs font-medium leading-normal text-normal"
          href="/my/privacy-policy"
          target="_blank"
        >
          {t('companyInfo.links.privacy')}
        </Link>
      </div>

      {/* 회사 정보 - 모바일 (778px 미만) */}
      <div className="font-pretendard flex flex-col gap-1 text-[11px] font-normal leading-[150%] text-neutral md:hidden lg:hidden">
        <div className="flex items-center gap-3">
          <span>
            {t('companyInfo.labels.name')} : {companyInfo.name}
          </span>
          <span>
            {t('companyInfo.labels.ceo')} : {companyInfo.representative_name}
          </span>
          <span>{companyInfo.representative_phone_number}</span>
        </div>
        <div>
          <span>
            {t('companyInfo.labels.businessNumber')} : {companyInfo.business_registration_number}
          </span>
        </div>
        <div>
          <span>
            {t('companyInfo.labels.mailOrderNumber')} : {companyInfo.mail_order_business_number}
          </span>
        </div>
        <div>
          {t('companyInfo.labels.address')} : {companyInfo.company_address},{' '}
          {companyInfo.company_detail_address}
        </div>
        {/* <div>Copyright © {companyInfo.name}. All rights reserved</div> */}
      </div>

      {/* 회사 정보 - 태블릿 (778px ~ 1023px) */}
      <div className="font-pretendard hidden flex-col gap-1 text-[11px] font-normal leading-[150%] text-neutral md:flex lg:hidden">
        <div className="flex items-center gap-3">
          <span>
            {t('companyInfo.labels.name')} : {companyInfo.name}
          </span>
          <span>
            {t('companyInfo.labels.ceo')} : {companyInfo.representative_name}
          </span>
          <span>{companyInfo.representative_phone_number}</span>
          <span>
            {t('companyInfo.labels.businessNumber')} : {companyInfo.business_registration_number}
          </span>
          <span>
            {t('companyInfo.labels.mailOrderNumber')} : {companyInfo.mail_order_business_number}
          </span>
        </div>
        <div>
          {t('companyInfo.labels.address')} : {companyInfo.company_address},{' '}
          {companyInfo.company_detail_address}
        </div>
        {/* <div className="mt-1">Copyright © {companyInfo.name}. All rights reserved</div> */}
      </div>

      {/* 회사 정보 - 데스크톱 (1024px 이상) */}
      <div className="font-pretendard hidden flex-col gap-1 text-[11px] font-normal leading-[150%] text-neutral md:hidden lg:flex">
        <div className="flex items-center gap-3">
          <span>
            {t('companyInfo.labels.name')} : {companyInfo.name}
          </span>
          <span>
            {t('companyInfo.labels.ceo')} : {companyInfo.representative_name}
          </span>
          <span>{companyInfo.representative_phone_number}</span>
          <span>
            {t('companyInfo.labels.businessNumber')} : {companyInfo.business_registration_number}
          </span>
          <span>
            {t('companyInfo.labels.mailOrderNumber')} : {companyInfo.mail_order_business_number}
          </span>
          <span>
            {t('companyInfo.labels.address')} : {companyInfo.company_address},{' '}
            {companyInfo.company_detail_address}
          </span>
        </div>
      </div>
    </>
  ) : null
}
